ApiError = require 'network/api-error'
React = require 'react'
t = require('views/internal/recup-with-helpers')('bc_info')
f = require 'effing'
format = require 'lib/format'

module.exports = class extends React.Component
  displayName: 'BC3UpgradeComponent'
  constructor: (props) ->
    super(props)

    @state = {
      showingYearly: false
      upgradeDisabled: false
      error: null
    }

  render: t.renderable ->
    { yearlyDiscountAmount, yearlyDiscount, isMonthly, userCount, onUpgradeClick, isPerActiveUser } = @props
    { showingYearly, upgradeDisabled, error } = @state
    showMonthly = isMonthly && !showingYearly
    isDiscounted = !(isMonthly || yearlyDiscount == 0)
    switchToYearly = f.choke 0, f(@, 'setState', showingYearly: true)
    switchToMonthly = f.choke 0, f(@, 'setState', showingYearly: false)
    { price, totalPrice, productNumber } = if showMonthly
        @props.monthly
      else
        @props.yearly

    setStateAndUpgrade = (el) =>
      @setState upgradeDisabled: true
      onUpgradeClick(productNumber, el)
      .catch ApiError.BadRequest, ApiError.Unauthorized, (err) =>
        @setState error: err.message, upgradeDisabled: false
      .done()
    yearlyDiscountAmount = format.money yearlyDiscountAmount
    price = format.money price
    totalPrice = format.money totalPrice

    t.div '.business-class-upgrade-box.u-gutter', ->
      if isPerActiveUser
        t.p ->
          t.format 'were also introducing smart billing…'

        t.p ->
          t.format 'theres also new pricing'

      t.p ->
        if isPerActiveUser
          if showMonthly
            t.format 'when paid monthly per active user', { price }
          else
            t.format 'when paid annually per active user', { price }
        else
          if showMonthly
            t.format 'when paid monthly per user', { price }
          else
            t.format 'when paid annually per user', { price }

      t.p ->
        if isPerActiveUser
          t.format 'your new price per month per active user', { totalPrice, userCount }
        else
          t.format 'your new price per month per user', { totalPrice, userCount }

      if isDiscounted
        t.p ->
          t.format 'discount upgrade to yearly',
            yearlyDiscountAmount: yearlyDiscountAmount
            yearlyDiscountPercent: format.percentage(yearlyDiscount)

      if error
        t.p ->
          t.text error

      t.button onClick: setStateAndUpgrade, class: 'primary', disabled: upgradeDisabled, ->
        t.format 'upgrade my team'

      t.p '.quiet.business-class-upgrade-box-spaced-item', ->
        if isDiscounted
          t.format 'youll be charged…minus your discount…', { totalPrice, yearlyDiscountAmount }
        else
          t.format 'youll be charged…', { totalPrice }

      if isMonthly
        t.p ->
          if showingYearly
            t.b switchToMonthly, ->
              t.format 'or go back to monthly pricing'
          else
            if yearlyDiscount > 0
              t.format 'or switch to paying annually…',
                yearlyDiscountPercent: format.percentage(yearlyDiscount)
              t.text ' '
            t.b switchToYearly, ->
              t.format 'see annual pricing'



// WEBPACK FOOTER //
// ./app/scripts/views/organization/bc3-upgrade-component.coffee